import React, { Component } from 'react'

import { Badge } from '@/components/ui/badge'
import { Card } from '@/components/ui/card'
import { Link } from 'react-router-dom'
import { Info } from 'react-feather'
import _kebabCase from 'lodash/kebabCase'

import BreadcrumbCard from '../utils/BreadcrumbCard';
import IpAddress from '../tools/IpAddress'
import Settings from '../pages/Settings'
import Utils from '../utils/Utils'

import '../App.css'

class About extends Component {
    static getTitle() {
        return "About"
    }
    static getSearchTitle() {
        return About.getTitle()
    }
    static getLink() {
        return '/' + _kebabCase(About.getSearchTitle())
    }
    static getTags() {
        return []
    }
    static getNavIcon(className) {
        return <Info className={ className } />
    }

    componentDidMount() {
        Utils.injectTwitterCardTags("About appler.dev")
    }
    componentWillUnmount() {
        Utils.removeTwitterCardTags()
    }

    render() {
        const breadcrumbs = [
            {
                title: About.getTitle(),
                active: true,
            }
        ]

        const ipAddressLink = '/' + _kebabCase(IpAddress.getSearchTitle())

        return (
            <BreadcrumbCard breadcrumbs={ breadcrumbs } id={ "about" }>
                <Card>
                <div className="p-6 space-y-3 text-sm leading-relaxed">
                    <h1>Welcome aboard!</h1>
                    <p>Here is a set of tools that might be useful for software developers.</p>
                    <p>I was tired of googling for this sort of tool all the time only
                    finding <i>have-not-been-updated-in-years</i> tools flooded with ads. So I ended up writing my
                    own, simply, why not?</p>
                    <p>It's written in JavaScript and based on React. I really tried to keep these tools fast
                    and simple.</p>
                    <p>So, enjoy!</p>
                    <p><strong>Privacy Policy</strong></p>
                    <ol className="list-decimal list-outside pl-5 space-y-2">
                        <li>Everything you'll be entering to the tools in this web site will stay inside your browser, and will
                        never be sent to the server in any form.  There are a couple of cases it'll make contact with the server:
                        <ul className="list-disc list-outside pl-5 mt-1">
                            <li><Link to={ ipAddressLink }>{ IpAddress.getTitle() }</Link> to determine the public IP
                                address of this computer.  This only happens if you click
                                the <Badge variant="outline">{ IpAddress.RETRIEVE_PUBLIC_IP_BUTTON }</Badge> button. Still, it
                                wouldn't send any particular information you've entered, but just a generic HTTP request
                                would be sent to the server.</li>
                        </ul></li>
                        <li>This tool will store the following information in the browser's localStorage:
                        <ul className="list-disc list-outside pl-5 mt-1">
                            <li>Word wrap preferences.</li>
                            <li>Various selections in some tools.</li>
                            <li>Preferences in <Link to={ Settings.getLink() }>Settings</Link>.</li>
                        </ul>
                        Don't forget that the tools here will not store any information you've entered, which means <strong>you'll
                        lose</strong> whatever you put down in the tool once you move to the other tool, even within this web
                        site. So please make sure you copy or download the data you want to save.</li>
                        <li>You don't need to sign up in any way to use these tools and never will have to
                        (it'd be laughable to write down your name to use a tool, for example, like a pair of scissors).</li>
                        <li>This web site has an analytics tool installed to measure traffic, and let me assure you that's not for
                        advertising.</li>
                    </ol>
                </div>
                </Card>
            </BreadcrumbCard>
        )
    }
}

export default About
